import {UniversityFieldTripsRFQFormData, PostalAddress} from './definitions';

const POSTAL_ADDRESS: PostalAddress = {
	streetAddress: null,
	postalCode: null,
	addressLocality: null,
	addressCountry: null,
};

const DEFAULT_PROPS: UniversityFieldTripsRFQFormData = {
	customer: {
		salutation: null,
		additionalType: null,
		givenName: null,
		familyName: null,
		address: POSTAL_ADDRESS,
		email: null,
		telephone: null,
	},
	participant: {
		name: null,
		address: POSTAL_ADDRESS
	},
	quoteRequest: {
		destination: null,
		offerPrice: null,
		offerIncludesAccommodation: [],
		offerIncludesTransportation: [],
		offerIncludesParticipants: {
			totalAmountOfParticipants: null,
		},
		offerIncludesSupervisors: null,
		customerAge: null,
		customerHandicap: null,
		arrivalTime: null,
		departureTime: null,
		departureStation: null,
		departureAirport: null,
		departureBusStation: null,
		duration: null,
		timeFlexibility: null,
		alternativeArrivalTime: null,
		alternativeDepartureTime: null,
		alternativeDuration: null,
		alternativeTimeFlexibility: null,
	},
	newsletter: false,
	referer: null,
	description: null,
};

export default DEFAULT_PROPS;
